import { CobaltButton } from '@cae/cobalt-react/components/button';
import {
  CobaltDropdown,
  CobaltDropdownItem,
} from '@cae/cobalt-react/components/dropdown';
import { CobaltPageHeader } from '@cae/cobalt-react/components/page-header';
import * as React from 'react';

import type { DocumentsHeaderProps } from './DocumentsHeader.types';

import { DocumentsSearch } from './documents-search/DocumentsSearch';
import styles from './DocumentsHeader.module.css';

const DocumentsHeader = React.memo(
  ({
    title,
    showOrgSelector = false,
    showSubmitButton = false,
    showSearch = true,
    onSubmitClick,
    onSearchActivate,
    organizations,
    selectedOrgId,
    onOrgChange,
  }: Readonly<DocumentsHeaderProps>): React.ReactElement => {
    const handleOrgChange = React.useCallback(
      (value: string | string[] | undefined): void => {
        if (!value) return;
        const orgId = Array.isArray(value) ? value[0] : value;
        onOrgChange?.(orgId);
      },
      [onOrgChange]
    );

    return (
      <section
        className={styles.documentsHeader}
        data-testid="documents-header"
      >
        <CobaltPageHeader
          title={title}
          actions={
            showSubmitButton && (
              <CobaltButton
                data-testid="submit-document-button"
                onClick={onSubmitClick}
              >
                Submit documents
              </CobaltButton>
            )
          }
          content={
            <div
              className={styles.documentsHeaderToolbar}
              data-testid="documents-header-toolbar"
            >
              {showOrgSelector && organizations && (
                <CobaltDropdown
                  className={styles.orgDropdown}
                  placeholder="Select organization"
                  value={selectedOrgId ?? ''}
                  onSelectionChange={handleOrgChange}
                  data-testid="documents-org-selector"
                  filterable
                >
                  {organizations.map(org => (
                    <CobaltDropdownItem key={org.id} value={org.id}>
                      {org.name}
                    </CobaltDropdownItem>
                  ))}
                </CobaltDropdown>
              )}
              {showSearch && <DocumentsSearch onActivate={onSearchActivate} />}
            </div>
          }
        />
      </section>
    );
  }
);

DocumentsHeader.displayName = 'DocumentsHeader';

export { DocumentsHeader };
